import { Api } from '../../services/api';
import { useContext } from "react";
import { AuthContext } from ".";
import endpoints from "../../utils/endpoints";
import { removeEmpty } from "../../utils/objectUtils";
import { notificationError } from "../../services/notification";

export const useAuth = () => {
    const context = useContext(AuthContext)
    //console.log(JSON.stringify(context))
    return context;
}

export async function sendSystemLog(params: any){
    let res = {
      return: false
    };
    params = removeEmpty(params);
    Api.get(endpoints.saveLog, {params}).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not log to system')
    });
    
    return res;
}
